import uuid from 'uuid'
/**
 *  
 */
export function getGuestId() {
  return uuid();
}
/**
 * 
 * @param {{guest_name, user_id, user_name}} pass 
 * @returns {{pass_id:string,guest_id:string,timestamp:string,description:string,status:string,guest_name:string,created:string,user_id:string,user_name:string,link:string}}
 */
export function getHistoryFromPutPass({ guest_name, user_id, user_name }) {
  const created = new Date().toISOString()
  const guest_id = getGuestId();
  return {
    pass_id: getPassId(user_id, created),
    guest_id,
    timestamp: created,
    description: `You created a pass for ${guest_name}`,
    status: "CREATED",
    guest_name,
    link: `/guest/${guest_id}`,
    user_id,
    user_name,
    created
  }
}
/**
 * 
 * @param {{guest_id:string,guest_name:string}} pass 
 */
export function getGuestFromPutPassEvent({ guest_id, guest_name }) {
  return {
    guest_id,
    guest_name,
    pin: getPin()
  };
}

/**
 * 
 * @param {{user_id:string,created:string}} pass 
 */
export function getPassId(user_id, created) {
  return `${created}_${user_id}`
}
export function getPin() {
  return `${Math.floor(1000 + Math.random() * 9000)}`;
}
/**
 * 
 * @param {{pk:string,sk:string,item:{created:string,description:string,name:string,pass_id:string,status:string,timestamp:string,user_id:string}}} _item 
 * @returns {{timestamp:string,pass_id:string,description:string,status:string}}
 */
export function localStorageItemAsHistory(_item) {
  const { item } = _item;
  return {
    ...item

  }
}
export function localStorageItemAsGuest(_item) {
  const { item } = _item;
  return {
    ...item
  }
}


// WEBPACK FOOTER //
// ./src/util/mock/selectors.js